// extracted by mini-css-extract-plugin
export default {"titleStyle":"procesos_titleStyle__2RUM4","rowStyle":"procesos_rowStyle__y4NNe"};